import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import { ToggleTemplate } from './ToggleTemplate';
import styles from '@patternfly/react-styles/css/components/Pagination/pagination';
import { css } from '@patternfly/react-styles';
import { Navigation } from './Navigation';
import { PaginationOptionsMenu } from './PaginationOptionsMenu';
import { getOUIAProps } from '../../helpers';
import widthChars from '@patternfly/react-tokens/dist/js/c_pagination__nav_page_select_c_form_control_width_chars';
export var PaginationVariant;

(function (PaginationVariant) {
  PaginationVariant["top"] = "top";
  PaginationVariant["bottom"] = "bottom";
})(PaginationVariant || (PaginationVariant = {}));

var defaultPerPageOptions = [{
  title: '10',
  value: 10
}, {
  title: '20',
  value: 20
}, {
  title: '50',
  value: 50
}, {
  title: '100',
  value: 100
}];

var handleInputWidth = function handleInputWidth(lastPage, node) {
  if (!node) {
    return;
  }

  var len = String(lastPage).length;

  if (len >= 3) {
    node.style.setProperty(widthChars.name, "".concat(len));
  } else {
    node.style.setProperty(widthChars.name, '2');
  }
};

var paginationId = 0;
export var Pagination =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Pagination, _React$Component);

  function Pagination() {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Pagination).apply(this, arguments));
    _this.paginationRef = React.createRef();
    return _this;
  }

  _createClass(Pagination, [{
    key: "getLastPage",
    value: function getLastPage() {
      var _this$props = this.props,
          itemCount = _this$props.itemCount,
          perPage = _this$props.perPage;
      return Math.ceil(itemCount / perPage) || 0;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = this.paginationRef.current;
      handleInputWidth(this.getLastPage(), node);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var node = this.paginationRef.current;

      if (prevProps.perPage !== this.props.perPage || prevProps.itemCount !== this.props.itemCount) {
        handleInputWidth(this.getLastPage(), node);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          children = _a.children,
          className = _a.className,
          variant = _a.variant,
          isDisabled = _a.isDisabled,
          isCompact = _a.isCompact,
          isStatic = _a.isStatic,
          perPage = _a.perPage,
          titles = _a.titles,
          firstPage = _a.firstPage,
          propPage = _a.page,
          offset = _a.offset,
          defaultToFullPage = _a.defaultToFullPage,
          itemCount = _a.itemCount,
          itemsStart = _a.itemsStart,
          itemsEnd = _a.itemsEnd,
          perPageOptions = _a.perPageOptions,
          dropDirectionProp = _a.dropDirection,
          widgetId = _a.widgetId,
          toggleTemplate = _a.toggleTemplate,
          onSetPage = _a.onSetPage,
          onPerPageSelect = _a.onPerPageSelect,
          onFirstClick = _a.onFirstClick,
          onPreviousClick = _a.onPreviousClick,
          onNextClick = _a.onNextClick,
          onPageInput = _a.onPageInput,
          onLastClick = _a.onLastClick,
          ouiaId = _a.ouiaId,
          props = __rest(_a, ["children", "className", "variant", "isDisabled", "isCompact", "isStatic", "perPage", "titles", "firstPage", "page", "offset", "defaultToFullPage", "itemCount", "itemsStart", "itemsEnd", "perPageOptions", "dropDirection", "widgetId", "toggleTemplate", "onSetPage", "onPerPageSelect", "onFirstClick", "onPreviousClick", "onNextClick", "onPageInput", "onLastClick", "ouiaId"]);

      var dropDirection = dropDirectionProp || (variant === 'bottom' && !isStatic ? 'up' : 'down');
      var page = propPage;

      if (!page && offset) {
        page = Math.ceil(offset / perPage);
      }

      var lastPage = this.getLastPage();

      if (page < firstPage && itemCount > 0) {
        page = firstPage;
      } else if (page > lastPage) {
        page = lastPage;
      }

      var firstIndex = itemCount <= 0 ? 0 : (page - 1) * perPage + 1;
      var lastIndex;

      if (itemCount <= 0) {
        lastIndex = 0;
      } else {
        lastIndex = page === lastPage ? itemCount : page * perPage;
      }

      return React.createElement("div", Object.assign({
        ref: this.paginationRef,
        className: css(styles.pagination, variant === PaginationVariant.bottom && styles.modifiers.bottom, isCompact && styles.modifiers.compact, isStatic && styles.modifiers.static, className),
        id: "".concat(widgetId, "-").concat(paginationId++)
      }, getOUIAProps('Pagination', ouiaId), props), variant === PaginationVariant.top && React.createElement("div", {
        className: css(styles.paginationTotalItems)
      }, React.createElement(ToggleTemplate, {
        firstIndex: firstIndex,
        lastIndex: lastIndex,
        itemCount: itemCount,
        itemsTitle: titles.items
      })), React.createElement(PaginationOptionsMenu, {
        itemsPerPageTitle: titles.itemsPerPage,
        perPageSuffix: titles.perPageSuffix,
        itemsTitle: isCompact ? '' : titles.items,
        optionsToggle: titles.optionsToggle,
        perPageOptions: perPageOptions,
        firstIndex: itemsStart !== null ? itemsStart : firstIndex,
        lastIndex: itemsEnd !== null ? itemsEnd : lastIndex,
        defaultToFullPage: defaultToFullPage,
        itemCount: itemCount,
        page: page,
        perPage: perPage,
        lastPage: lastPage,
        onPerPageSelect: onPerPageSelect,
        dropDirection: dropDirection,
        widgetId: widgetId,
        toggleTemplate: toggleTemplate,
        isDisabled: isDisabled
      }), React.createElement(Navigation, {
        pagesTitle: titles.page,
        toLastPage: titles.toLastPage,
        toPreviousPage: titles.toPreviousPage,
        toNextPage: titles.toNextPage,
        toFirstPage: titles.toFirstPage,
        currPage: titles.currPage,
        paginationTitle: titles.paginationTitle,
        page: itemCount <= 0 ? 0 : page,
        perPage: perPage,
        firstPage: itemsStart !== null ? itemsStart : 1,
        lastPage: lastPage,
        onSetPage: onSetPage,
        onFirstClick: onFirstClick,
        onPreviousClick: onPreviousClick,
        onNextClick: onNextClick,
        onLastClick: onLastClick,
        onPageInput: onPageInput,
        isDisabled: isDisabled,
        isCompact: isCompact
      }), children);
    }
  }]);

  return Pagination;
}(React.Component);
Pagination.defaultProps = {
  children: null,
  className: '',
  variant: PaginationVariant.top,
  isDisabled: false,
  isCompact: false,
  perPage: defaultPerPageOptions[0].value,
  titles: {
    items: '',
    page: '',
    itemsPerPage: 'Items per page',
    perPageSuffix: 'per page',
    toFirstPage: 'Go to first page',
    toPreviousPage: 'Go to previous page',
    toLastPage: 'Go to last page',
    toNextPage: 'Go to next page',
    optionsToggle: 'Items per page',
    currPage: 'Current page',
    paginationTitle: 'Pagination'
  },
  firstPage: 1,
  page: 0,
  offset: 0,
  defaultToFullPage: false,
  itemsStart: null,
  itemsEnd: null,
  perPageOptions: defaultPerPageOptions,
  widgetId: 'pagination-options-menu',
  toggleTemplate: ToggleTemplate,
  onSetPage: function onSetPage() {
    return undefined;
  },
  onPerPageSelect: function onPerPageSelect() {
    return undefined;
  },
  onFirstClick: function onFirstClick() {
    return undefined;
  },
  onPreviousClick: function onPreviousClick() {
    return undefined;
  },
  onNextClick: function onNextClick() {
    return undefined;
  },
  onPageInput: function onPageInput() {
    return undefined;
  },
  onLastClick: function onLastClick() {
    return undefined;
  },
  ouiaId: null
};